export * from 'shared/origin/origin';